export default __webpack_public_path__ + "static/media/private.be062248.svg";